interface AvatarProps {
	src?: string | null;
	alt: string;
	width?: number;
	height?: number;
	className?: string;
	fallbackText?: string;
}

export function Avatar({ src, alt, className = '', fallbackText = '' }: AvatarProps) {
	return (
		<div className={`relative flex rounded-full bg-gray-300 ${className}`}>
			{src ? (
				<img src={src} alt={alt} className="rounded-full size-[60px] " />
			) : (
				<span className="flex size-[60px] items-center justify-center rounded-full bg-darkorange-400 text-[40px] font-bold text-white">
					{fallbackText}
				</span>
			)}
		</div>
	);
}
